import AuthService from '../Security/AuthService.js';

let inactivityTimeout;
let warningTimeout;

function resetInactivityTimer() {
    clearTimeout(inactivityTimeout);
    clearTimeout(warningTimeout);

    warningTimeout = setTimeout(() => {
        alert("You will be logged out in 1 minute due to inactivity.");
    }, 4 * 60 * 1000); // 4 min

    inactivityTimeout = setTimeout(() => {
        logoutUser(true); // Auto logout
    }, 5 * 60 * 1000); // 5 min
}

function checkSessionExpiration() {
    const expirationTime = sessionStorage.getItem('sessionExpires');
    const token = localStorage.getItem('jwt');

    // Only check expiration if user is logged in
    if (token && (!expirationTime || Date.now() > parseInt(expirationTime))) {
        logoutUser(false);
    } else if (token) {
        resetInactivityTimer();
    }
}

async function logoutUser(isInactivity = false) {
    const authService = new AuthService();
    try {
        await authService.logout(); // Optional: invalidate server-side session
    } catch (error) {
        console.warn("Logout API failed:", error);
    }

    // Clear storage
    sessionStorage.clear();
    localStorage.removeItem('jwt');
    localStorage.removeItem('role');
    localStorage.removeItem('patientId');
    localStorage.removeItem('doctorId');

    if (isInactivity) {
        alert("You have been logged out due to inactivity.");
    } else {
        alert("Your session has expired. Please log in again.");
    }

    // ⬇️ Redirect based on last known role
    const role = localStorage.getItem('role');
    if (role === 'PATIENT') {
        window.location.href = '/login/patient';
    } else {
        window.location.href = '/login/doctor';
    }
}

// Listen for user interaction
document.addEventListener('mousemove', resetInactivityTimer);
document.addEventListener('keydown', resetInactivityTimer);
document.addEventListener('click', resetInactivityTimer);
document.addEventListener('scroll', resetInactivityTimer);

export { checkSessionExpiration, resetInactivityTimer, logoutUser };
